export const PXVideo = (function() {
	'use strict';

	let $video, $image, $iframe;

	function init() {
		events();
	}

	function events() {
		$video = $('.pxblock--video__video');

		$video.each(function(){
			let $this = $(this);
			$image = $this.find('.pxblock--video__image');
			$iframe = $this.find('iframe, video, embed');
			// console.log($iframe.attr('src'));

			$image.on('click', function(){
				$(this).fadeTo('slow', 0).css('z-index', '-1');
				$iframe.attr('src', $iframe.attr('data-src') ).fadeTo('slow', 1);
			});
		});
	}

	return {
		init: init
	};
})();
